"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
exports.createMuiBackdropOverrides = function (theme) {
    return {
        root: {
            backgroundColor: styles_1.fade(theme.palette.common.black, 0.7),
        },
    };
};
//# sourceMappingURL=MuiBackdrop.js.map